import { gql } from "@apollo/client";
import CreateConfigItemDialog from "./CreateConfigItemDialog";

const CREATE_SERVICE_LINE = gql(`
  mutation CreateServiceLine(
    $name: String!
  )
  @permission(requires: manageOrgConfig)
  {
    createServiceLine(
      name: $name
    ) {
      id
      name
    }
  }
`);

type CreateServiceLineDialogProps = {
  open: boolean;
  onClose: () => void;
};

const CreateServiceLineDialog = ({ open, onClose }: CreateServiceLineDialogProps) => {
  return (
    <CreateConfigItemDialog
      open={open}
      onClose={onClose}
      title="Create Service Line"
      mutation={CREATE_SERVICE_LINE}
      mutationName="createServiceLine"
      redirectPath="/operate-config/service-lines"
    />
  );
};

export default CreateServiceLineDialog;
